import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogRef } from '@angular/material/dialog';
import { TagConcatField } from '../../model/tag-concat-field';
import { TagFieldUpdateRequest } from '../../model/tag-field-update-request';
import { TagFieldUpdateResult } from '../../model/tag-field-update-result';

@Component({
  selector: 'app-set-tag-field-dialog',
  templateUrl: './set-tag-field-dialog.component.html',
  styleUrls: ['./set-tag-field-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, MatButton, MatDialogActions],
})
export class SetTagFieldDialogComponent {
  private readonly dialogRef = inject<MatDialogRef<SetTagFieldDialogComponent>>(MatDialogRef);
  readonly data = inject<TagFieldUpdateRequest>(MAT_DIALOG_DATA);
  sourceFields: TagConcatField[] = this.buildSourceFields();
  strategy = 'field';
  selectedField: string = this.sourceFields[0].code;
  customValue = '';
  scope = 'all';

  private buildSourceFields(): TagConcatField[] {
    const baseFields: TagConcatField[] = [
      { selected: false, code: 'riser', description: 'Riser' },
      { selected: false, code: 'floor', description: 'Floor' },
      { selected: false, code: 'room', description: 'Room' },
      { selected: false, code: 'building', description: 'Bldg' },
      { selected: false, code: 'poLine', description: 'PO Line' },
    ];
    if (this.data.target !== 'location') {
      baseFields.unshift({ selected: false, code: 'tag', description: 'Tag' });
    }
    return baseFields;
  }

  private selectedConcatFields(): string[] {
    return this.sourceFields.filter((field) => field.selected).map((field) => field.code);
  }

  apply(): void {
    const result: TagFieldUpdateResult = {
      strategy: this.strategy,
      field: this.selectedField,
      concatFields: this.selectedConcatFields(),
      customValue: this.customValue,
      scope: this.scope,
    };
    this.dialogRef.close(result);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
